export default "__VITE_ASSET__BjFIb8Ok__"